import Vue from 'vue';
import wysiwyg from 'vue-wysiwyg';

Vue.use(wysiwyg, {});



// WEBPACK FOOTER //
// ./src/plugins/wysiwyg/index.js